import classnames from 'classnames';
import { eachDayOfInterval, endOfWeek, format, isWeekend, startOfWeek } from 'date-fns';
import deLocale from 'date-fns/locale/de';
import React from 'react';
import styles from "./DateOverviewCalendar.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DateOverviewCalendar = ({
  date
}) => {
  function getWeek(weekStartOn) {
    const end = endOfWeek(date, {
      weekStartsOn: weekStartOn
    });
    const week = eachDayOfInterval({
      start: startOfWeek(date, {
        weekStartsOn: weekStartOn
      }),
      end: end.setDate(end.getDate() - 2)
    });
    return /*#__PURE__*/_jsxs("div", {
      className: styles.days,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.week,
        children: week.map((d, i) => /*#__PURE__*/_jsx("div", {
          className: classnames(styles.day, {
            [styles.weekend]: isWeekend(d)
          }),
          children: format(d, 'EE', {
            locale: deLocale
          }).replace('.', '')
        }, i))
      }), /*#__PURE__*/_jsx("div", {
        className: styles.week,
        children: week.map((d, i) => /*#__PURE__*/_jsx("div", {
          className: classnames(styles.day, {
            [styles.active]: d.getDate() === date.getDate(),
            [styles.weekend]: isWeekend(d)
          }),
          children: format(d, 'd')
        }, i))
      })]
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: styles.dateOverviewCalendar,
    children: isWeekend(date) ? getWeek(3) : getWeek(1)
  });
};